import { atom } from 'recoil'
import { PropertiesSchema } from '../hooks/use-schema/useSchema'

export const schemaState = atom<{[key: string]: PropertiesSchema}>({
  key: 'schema-state',
  default: {}
})
